// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"194":"74921861e81ae7f57cdf","195":"9b5e92c9172ec7406271"}[chunkId] + ".js";
};